import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'browser-compatibility',
	template: require('./browser-compatibility.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class BrowserCompatibilityComponent {
	public isRebrading = AppSettings.isRebrading;
}
